import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
  FormGroup,
  FormControlLabel,
  Checkbox, Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import axios from "../../../../lib/axios";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const columns = [
  { id: 'RowNum', label: 'S.No.', minWidth: 170 },
  { id: 'VndRtgName', label: 'Vendor Name', minWidth: 100 },
  { id: 'VndRtgAbrv', label: 'Vendor Abrv', minWidth: 100 },
  { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const RatingMaster = () => {
  const [formData, setFormData] = useState({
    VndRtgName: '',
    VndRtgAbrv: '',
    Remark: ''
  });

  const [error, setError] = useState({
    VndRtgName: false,
    VndRtgAbrv: false
  });

  const navigate = useNavigate();

  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const location = useLocation();
  const [currentVndRtgId, setCurrentVndRtgId] = useState(null);
  const [mode, setMode] = useState('view');
  const [Status, setStatus] = useState("1");
  const [lastInsertedVndRtgId, setLastInsertedVndRtgId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const ratingNameRef = useRef(null);
  const ratingAbrvRef = useRef(null);
  const remarkRef = useRef(null);

  useEffect(() => {
    if (location.state && location.state.VndRtgId) {
      setCurrentVndRtgId(location.state.VndRtgId);
      fetchRatingData(location.state.VndRtgId);
      setMode('view');
    } else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchRatingData = async (id, flag) => {
    try {
      const response = await axiosInstance.post(`MstVendRating/RetriveMstVndRtg`, {
        VndRtgId: parseInt(id),
        Flag: flag
      }
      );

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const ratingData = response.data.Data[0];
        setFormData({
          VndRtgName: ratingData.VndRtgName,
          VndRtgAbrv: ratingData.VndRtgAbrv,
          Remark: ratingData.Remark
        });
        setStatus(ratingData.Status.toString() || "0");
        setIsFormDisabled(true);
        setCurrentVndRtgId(ratingData.VndRtgId);
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch rating data');
      }
    } catch (error) {
      toast.error('Error fetching rating data. Please try again.');
    }
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };

      try {
        const res = await axios.post('MstVendRating/GetMstVndRtgDashBoard', { params });

        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);

  const handlePrevious = async () => {
    if (currentVndRtgId && currentVndRtgId > 1) {
      await fetchRatingData(currentVndRtgId, "P");
    }
  };

  const handleNext = async () => {
    if (currentVndRtgId) {
      await fetchRatingData(currentVndRtgId, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'Rating') {
      setFormData(prevState => ({
        ...prevState,
        state: ''
      }));
    }

    if (name === 'Rating' && value !== '') {
      setTimeout(() => {
        remarkRef.current.focus();
      }, 100000);
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (event.target === ratingNameRef.current) {
        ratingAbrvRef.current.focus();
      } else {
        remarkRef.current.focus();
      }
    }
  };

  const handleSubmit = async () => {

    let hasError = false;

    if (!formData.VndRtgName) {
      toast.error('Rating is required');
      setError(prev => ({ ...prev, VndRtgName: true }));
      hasError = true;
    } else {
      setError(prev => ({ ...prev, VndRtgName: false }));
    }

    if (hasError) {
      return;
    }

    try {
      const payload = {
        VndRtgName: formData.VndRtgName,
        VndRtgAbrv: formData.VndRtgAbrv,
        Remark: formData.Remark,
        Status: Status
      };

      let response;
      if (mode === 'edit') {
        payload.VndRtgId = currentVndRtgId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axiosInstance.patch(`MstVendRating/UpdateMstVndRtg`, payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axiosInstance.post(`MstVendRating/InsertMstVndRtg`, payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === 'add') {
          setLastInsertedVndRtgId(response.data.Data)
          await fetchRatingData(response.data.Data);
          setMode('view');
          setIsFormDisabled(true);
          setCurrentVndRtgId(response.data.Data);
        } else {
          setMode('view');
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || 'Operation failed');
      }
    } catch (error) {
      console.error('Error saving/updating rating:', error);
      toast.error('Error saving/updating Rating. Please try again.');
    }
  };

  const handleEdit = async () => {
    let Flag = await checkAndLock(currentVndRtgId, "MstVndRtg", "VndRtgId");
    switch (Flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);
    setFormData({
      VndRtgName: '',
      VndRtgAbrv: '',
      Remark: ''
    });
    setCurrentVndRtgId(null);

    setTimeout(() => {
      ratingNameRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    try {
      await fetchRatingData(1, "L");
      await UnLock(currentVndRtgId, "MstVndRtg", "VndRtgId");
      setStatus("1");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error occurred while cancelling. Please try again.');
    }
  };

  const resetForm = () => {
    setFormData({
      VndRtgName: '',
      VndRtgAbrv: '',
      Remark: ''
    });
    setCurrentVndRtgId(null);
    setMode('view');
  };

  const handleExit = () => {
    navigate('/ratingtable')
  }

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    let Flag = await checkAndLock(currentVndRtgId, "MstVndRtg", "VndRtgId");
    switch (Flag) {
      case 0:
        setOpenConfirmDialog(false);
        await fetchRatingData(currentVndRtgId, "D");
        await fetchRatingData(currentVndRtgId, "N");
        setStatus("1");
        setMode('view');
        setIsFormDisabled(true);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });

    }
  };

  return (
    <>
      <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
        <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
          <Grid item xs={12} className='form_title'
            sx={{
              display: 'flex', alignItems: 'center',
              justifyContent: 'space-between', marginTop: '20px',
              flexDirection: { xs: 'column', sm: 'row', md: 'row' }
            }}
          >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                onClick={handlePrevious}
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentVndRtgId || currentVndRtgId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                className='three-d-button-next'
                onClick={handleNext}
                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentVndRtgId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              Rating Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName={"Rating Master"}
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className='form_field'>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={3}>
                <TextField
                  id="VndRtgName"
                  name="VndRtgName"
                  label={
                    <span>
                      Rating Name<span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.VndRtgName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.VndRtgName}
                  helperText={error.VndRtgName && ""}
                  inputRef={ratingNameRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid item xs={12} md={4} lg={3}>
                <TextField
                  id="VndRtgAbrv"
                  name="VndRtgAbrv"
                  label="Abrv"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.VndRtgAbrv}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={ratingAbrvRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid item xs={12} md={4} lg={3}>
                <TextField
                  id="Remark"
                  name="Remark"
                  label="Remark"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Remark}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={remarkRef}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === 'view' && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === 'edit' || mode === 'add') && (
              <>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
          columns={columns}
          rows={rows}
          title="Rating Master"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>

          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default RatingMaster;